import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';


import { Configuracion } from 'src/app/shared/model/emision/configuracion.model';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { ConfiguracionGeneral } from 'src/app/shared/model/emision/configuracionGeneral.model';
import { UrlConstantes } from '../utilerias/constantes/urlconstantes';


@Injectable()
export class ConfiguracionService {
    constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient) { }
  selectConfiguraciones(configuracion: Configuracion) {
    return this.http.post<ConsultaList<Configuracion>>(UrlConstantes.BUSCA_CONFIG, configuracion, { });
  }
  selectConfiguracionesSec(confGral: ConfiguracionGeneral) {
    return this.http.post<ConsultaList<ConfiguracionGeneral>>(UrlConstantes.BUSCAGEN_CONFIG, confGral, { });
  }
  saveConf(confGral: ConfiguracionGeneral) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': btoa('ADMIN'),
      'X-Requested-With': 'XMLHttpRequest',
    })
    return this.http.post(UrlConstantes.SAVEUPDATE_CONFIG, confGral, 
    {headers: headers, responseType: 'text', observe: 'response' });
  }
  deleteConf (configuracion: ConfiguracionGeneral) {
    return this.http.post(UrlConstantes.DELETE_CONFIG,configuracion,{});
  }
}
